import {newsContentManager} from '../../../api/newsContentManager';

import EventItemDto from '../../../api/eventItemDto';
import { actionTypes } from '../../../common/constants/actionTypes';

import { httpCallStartAction } from '../../../middlewares/http/actions';

export const fetchEventItemsAction = () => (dispatch: any) => {
    dispatch(httpCallStartAction());
    
    newsContentManager.fetchEventsItemsAsync({limit: 3})
    .then((eventItems) => {
      dispatch(fetchEventsItemsCompleted(eventItems));
    });
};

const fetchEventsItemsCompleted = (eventItems: EventItemDto) => ({
    meta: {
        httpEnd: true,
      },
    payload: eventItems,
    type: actionTypes.FETCH_EVENT_ITEMS
});


// WEBPACK FOOTER //
// ./src/components/latestEventsListBlock/actions/fetchEventsItems.ts